export default __webpack_public_path__ + "static/media/OSMOS_TORTORA-MATT_60X120_07.99bf9735.jpg";